module.exports = __webpack_public_path__ + "img/怄火.a84f8d0a.gif";